import { Font, StyleSheet } from '@react-pdf/renderer';
import RobotoRegular from '../../../styles/Roboto-Regular.ttf';
import RobotoBold from '../../../styles/Roboto-Bold.ttf';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: RobotoRegular,
      fontWeight: 'normal',
    },
    {
      src: RobotoBold,
      fontWeight: 'bold',
    },
  ],
});

export const leaveApplicationPDFStyles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    fontSize: 11,
    padding: 30,
  },
  tab: {
    paddingLeft: 20,
  },
  header: {
    fontSize: 11,
    textAlign: 'center',
    marginTop: 90,
    marginBottom: 80,
    fontWeight: 'bold',
  },
  mainText: {
    marginBottom: 20,
    textAlign: 'justify',
    marginHorizontal: 50,
  },
  dateAndEmployeeSignatureSection: {
    marginTop: 60,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  managerSignatureSection: {
    marginTop: 80,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  signature: {
    minWidth: 300,
    alignItems: 'center',
  },
  signatureImage: {
    marginTop: 4,
    height: 30,
    objectFit: 'contain',
  },
  date: {
    marginHorizontal: 50,
    textAlign: 'left',
  },
});
